import {apiPost,apiGet} from "./apiUtils";
import { getLoggedInUserTenantID } from "./sessionUtil";


// const environments = [
//     {
//         "name": "DEV",
//         "description": "This is dev "
//     },
//     {
//         "name": "QA",
//         "description": "This is QA environment"
//     },
//     {
//         "name": "UAT",
//         "description": "This is UAT environment"
//     },
//     {
//         "name": "PROD",
//         "description": "This is PROD environment"
//     }

// ];


export function getEnvironments(){
    // return new Promise(function (resolve,reject){
    //     resolve(environments);
    // });
    let tenantId = getLoggedInUserTenantID();
    let url = `${process.env.REACT_APP_API_PREFIX}/environment/getEnvironmentsByTenantId/${tenantId}`;
    return apiGet(url);
 


} 

   


export function deleteEnvironment(env){
    // let i = environments.findIndex((e)=>e.name === env.name);
    // environments.splice(i,1);
}

export function addEnvironment(env){
    // environments.push(env);
    let tenantId = getLoggedInUserTenantID();
    let url = `${process.env.REACT_APP_API_PREFIX}/environment/createEnvironment`;
    let body = {"tenantId":tenantId, "environment":env, "sequenceNumber":1} 
    return apiPost(url, body);

}

export function updateEnvironment(env){
    // let i = environments.findIndex((e)=>e.name === env.name);
    // environments[i] = {...env};
}

